module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('workspace', [_c('div', {
    attrs: {
      "slot": "form"
    },
    slot: "form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "kicker"
    }
  }, [_vm._v("Kicker")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kicker),
      expression: "kicker"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "kicker"
    },
    domProps: {
      "value": (_vm.kicker)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.kicker = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "headline"
    }
  }, [_vm._v("Headline")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headline),
      expression: "headline"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "headline"
    },
    domProps: {
      "value": (_vm.headline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headline = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "excerpt"
    }
  }, [_vm._v("Excerpt")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.excerpt),
      expression: "excerpt"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "excerpt"
    },
    domProps: {
      "value": (_vm.excerpt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.excerpt = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "link"
    }
  }, [_vm._v("Story link")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.link),
      expression: "link"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "link"
    },
    domProps: {
      "value": (_vm.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.link = $event.target.value
      }
    }
  })]), (this.$options.name != 'the-do-brief') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "buttonText"
    }
  }, [_vm._v("Button Text")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buttonText),
      expression: "buttonText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "buttonText"
    },
    domProps: {
      "value": (_vm.buttonText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.buttonText = $event.target.value
      }
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "imageUrl"
    }
  }, [_vm._v("Image URL")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imageUrl),
      expression: "imageUrl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "imageUrl"
    },
    domProps: {
      "value": (_vm.imageUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imageUrl = $event.target.value
      }
    }
  })]), (_vm.hasRules) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "checkbox-inline"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleBelow),
      expression: "ruleBelow"
    }],
    attrs: {
      "type": "checkbox",
      "name": "rule_below"
    },
    domProps: {
      "checked": Array.isArray(_vm.ruleBelow) ? _vm._i(_vm.ruleBelow, null) > -1 : (_vm.ruleBelow)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ruleBelow,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ruleBelow = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.ruleBelow = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ruleBelow = $$c
        }
      }
    }
  }), _vm._v("Rule below")]), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleAbove),
      expression: "ruleAbove"
    }],
    attrs: {
      "type": "checkbox",
      "name": "rule_above"
    },
    domProps: {
      "checked": Array.isArray(_vm.ruleAbove) ? _vm._i(_vm.ruleAbove, null) > -1 : (_vm.ruleAbove)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.ruleAbove,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.ruleAbove = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.ruleAbove = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.ruleAbove = $$c
        }
      }
    }
  }), _vm._v("Rule above")])])]) : _vm._e(), _c('div', {
    staticClass: "form-group clearfix",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "refresh"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-refresh"
  }), _vm._v(" Reset")]), _c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "copyHtml",
      "aria-label": "Copied HTML!"
    },
    on: {
      "click": _vm.copy
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-copy"
  }), _vm._v(" Copy HTML")]), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "id": "copyTextVersion",
      "data-component": _vm.currentTemplate,
      "aria-label": "Copied Text!"
    },
    on: {
      "click": _vm.copyTextVersion
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-copy"
  }), _vm._v(" Copy text")])])])]), _c('table', {
    staticStyle: {
      "border-collapse": "collapse"
    },
    attrs: {
      "slot": "render",
      "width": "100%",
      "cellspacing": "0",
      "cellpadding": "0",
      "align": "center"
    },
    slot: "render"
  }, [(_vm.ruleAbove) ? _c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('table', {
    staticClass: "fullwidth",
    staticStyle: {
      "border-collapse": "collapse",
      "height": "50px"
    },
    attrs: {
      "width": "319",
      "cellspacing": "0",
      "cellpadding": "0",
      "align": "center"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "1px solid #efefef"
    }
  }, [_vm._v(" ")])]), _c('tr', [_c('td', [_vm._v(" ")])])])])]) : _vm._e(), _c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('table', {
    staticClass: "fullwidth",
    staticStyle: {
      "border-collapse": "collapse"
    },
    attrs: {
      "width": "320",
      "cellspacing": "0",
      "cellpadding": "0",
      "align": "center"
    }
  }, [_c('tr', [_c('td', [_c('a', {
    attrs: {
      "href": _vm._f("stripSpaces")(_vm.link),
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "fullwidth",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "alt": "Image",
      "border": "0",
      "src": _vm._f("stripSpaces")(_vm.imageUrl),
      "width": "320"
    }
  })])])]), _c('tr', [_c('td', [_vm._v(" ")])])])])]), _c('tr', [_c('td', [_c('table', {
    staticClass: "fullwidth",
    staticStyle: {
      "border-collapse": "collapse"
    },
    attrs: {
      "width": "480",
      "cellspacing": "0",
      "cellpadding": "0",
      "align": "center"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "align": "center",
      "width": "15"
    }
  }, [_c('img', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "alt": "",
      "border": "0",
      "height": "15",
      "src": "https://resources.osteopathic.org/l/979203/2023-11-13/c7zt4/979203/1699890535jNe7NLJe/spacer.gif",
      "width": "15"
    }
  })]), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('table', {
    staticClass: "fullwidth",
    staticStyle: {
      "border-collapse": "collapse"
    },
    attrs: {
      "width": "400",
      "cellspacing": "0",
      "cellpadding": "0",
      "align": "center"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "font-family": "helvetica",
      "font-size": "12px",
      "color": "#22528e",
      "line-height": "18px",
      "padding-bottom": "10px",
      "font-weight": "400",
      "text-transform": "uppercase",
      "letter-spacing": "1px"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.kicker))])]), _c('tr', [_c('td', {
    staticStyle: {
      "font-family": "helvetica",
      "font-size": "14pt",
      "color": "#2a2a2a",
      "line-height": "18px",
      "padding-bottom": "10px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#2a2a2a",
      "text-decoration": "none",
      "font-family": "helvetica",
      "font-size": "20px",
      "line-height": "26px",
      "font-weight": "700"
    },
    attrs: {
      "href": _vm._f("stripSpaces")(_vm.link),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.headline))])])]), _c('tr', [_c('td', {
    staticStyle: {
      "font-family": "helvetica",
      "font-size": "14px",
      "color": "#686d75",
      "line-height": "20px",
      "font-weight": "normal"
    },
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.excerpt))])]), _c('tr', [_c('td', [_vm._v(" ")])])])]), _c('td', {
    attrs: {
      "align": "center",
      "width": "15"
    }
  }, [_c('img', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "alt": "",
      "border": "0",
      "height": "15",
      "src": "https://resources.osteopathic.org/l/979203/2023-11-13/c7zt4/979203/1699890535jNe7NLJe/spacer.gif",
      "width": "15"
    }
  })])])])])]), _c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('table', {
    staticClass: "fullwidth",
    staticStyle: {
      "border-collapse": "collapse"
    },
    attrs: {
      "width": "480",
      "cellspacing": "0",
      "cellpadding": "0",
      "align": "center"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "font-size": "0px",
      "padding": "10px 25px",
      "word-break": "break-word",
      "color": "#ffffff"
    },
    attrs: {
      "align": "center",
      "vertical-align": "middle"
    }
  }, [_c('table', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "role": "presentation",
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "body-text",
    staticStyle: {
      "font-size": "0px",
      "padding": "10px 25px",
      "word-break": "break-word"
    },
    attrs: {
      "align": "center",
      "vertical-align": "middle"
    }
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "separate",
      "line-height": "100%"
    },
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "role": "presentation"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border": "none",
      "border-radius": "4px",
      "cursor": "auto",
      "padding": "10px 35px",
      "background": "#22528e",
      "color": "#ffffff"
    },
    attrs: {
      "align": "center",
      "bgcolor": "#22528e",
      "role": "presentation",
      "valign": "middle"
    }
  }, [_c('a', {
    staticStyle: {
      "background": "#22528e",
      "color": "#ffffff",
      "font-family": "Helvetica, Arial, sans-serif",
      "font-size": "18px",
      "font-weight": "normal",
      "line-height": "120%",
      "Margin": "0",
      "text-decoration": "none",
      "text-transform": "none"
    },
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])])])])])])]), _vm._v("-->"), _vm._v("-->")])])])])]), (_vm.ruleBelow) ? _c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('table', {
    staticClass: "fullwidth",
    staticStyle: {
      "border-collapse": "collapse",
      "height": "50px"
    },
    attrs: {
      "width": "319",
      "cellspacing": "0",
      "cellpadding": "0",
      "align": "center"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border-bottom": "1px solid #efefef"
    }
  }, [_vm._v(" ")])]), _c('tr', [_c('td', [_vm._v(" ")])])])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e4f4f08"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/the-do/feature.vue
// module id = 218
// module chunks = 0